export default __webpack_public_path__ + "static/media/footer-copyright-vector.fea946cf.svg";